import React, { useEffect, useState } from "react"; import { Field, FormikProvider, Form, useFormik } from "formik";import Select from 'react-select'; import Menubar from "../Menubar"; import { store } from "../../App"; import MasterService from "../../Services/MasterService"; import { AiFillFileExcel, AiOutlineSearch, } from "react-icons/ai"; import { Container, Row, Col, Nav, Button } from 'react-bootstrap'; import { MdOutlinePictureAsPdf } from "react-icons/md"; import "jspdf-autotable"; import { commonSelectProps, currentDate, datetime, exportToExcel, formatNumberIndianWithDecimal, generatePdf } from "../utils/commonFunctions"; import AlertModal from "../Alert/AlertModal"; import useAlert from "../Alert/useAlert"; import KpiService from "../../Services/KpiService";
export default function HodKpiIndicatorReport() {
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert();
  const [distEnb, setDistEnb] = useState(false); const [Mandalenb, setMandalenb] = useState(false);
  const [distlist, setDistrictList] = useState(); const [mandallist, setMandalList] = useState(); const [Periodicitylist, setPeriodicitylist] = useState(); const [Yearlist, setYearlist] = useState();
  const [Categorylist, setCategorylist] = useState();const [searchText1, setSearch1] = useState(""); const [Id, setId] = useState(); const [Periodicid, setperiodicId] = useState();
  const [EntryData, setEntrydata] = useState(); const [entrydataEnb, setEntrydataEnb] = useState(false); const [Asotableenb, setAsotableenb] = useState(false); const [Cpodata, setCpodata] = useState([]);
  const [Deptlist, setDeptlist] = useState([]); const [Deptname, setDeptname] = useState(); const [years, setyears] = useState(); const [categorys, setcategorys] = useState();
  const [selectedperiodicity, setselectedperiodicity] = useState(); const [selectedyear, setselectedyear] = useState(); const [selectedcategory, setselectedcategory] = useState();
  let username = localStorage.getItem("username"); let roleid = localStorage.getItem("catid"); let district = localStorage.getItem("districtid"); let mandal = localStorage.getItem("mandalid");
  let deptId = localStorage.getItem("deptid"); 
  const formik = useFormik({
    initialValues: { userId: "", district_id: "", mandal_id: "", department_id: "", periodic_id: "", year: "", date: "", Indicators: [{ indicator_id: "", entry_value: "" }], remarks: "" },
  })
  const [currentdate, setcurrentdate] = useState(''); const [currenttime, setcurrenttime] = useState('');
  useEffect(() => { if (["111", "113", "114"].includes(roleid)) { perioicitylist(deptId);formik.setFieldValue("department_id",deptId) } datetime(setcurrentdate, setcurrenttime); }, []); const [Depts, setDepts] = useState();
  React.useEffect(() => {
    if ((roleid === "111") || (roleid === "113")) {
      setDistEnb(true); setMandalenb(true);
    }
    if (roleid === "117") {
      setDistEnb(true); setMandalenb(true);
    }
    if (roleid === "116") {
      setDistEnb(false);
    }
    if (roleid === "113" || roleid === "119") {
      setDistEnb(true);
    }
    formik.setFieldValue("district_id", district)
    let params = { "district_id": district }
    MasterService.getMandals(params).then((res) => {
      if (res.data) { let options = res.data.map((item, i) => { return (<option key={i} value={item.id}> {item.value} </option>); }); setMandalList(options); }
    });
    formik.setFieldValue("mandal_id", mandal)
  }, []);
  const periodicityMap = { monthly: { label: "MONTHLY", value: "6" }, quarterly: { label: "QUARTERLY", value: "7" }, half_yearly: { label: "HALFYEARLY", value: "5" }, annually: { label: "ANNUALLY", value: "3" }, bi_annual: { label: "BIENNIAL", value: "8" }, five_years: { label: "FIVE-YEARS", value: "2" } };
  const perioicitylist = (dept) => {
    if (dept === "0") {      const allOptions = Object.keys(periodicityMap).map((key) => ({ label: periodicityMap[key].label, value: periodicityMap[key].value, }));
 setPeriodicitylist(allOptions); return; }
    else {
      let paramss = { userId: username, deptId: dept, mandal: "No", district: "No", state: "Yes", secretariat: "No", };
      KpiService.getperiodicityStatusForAchievementsEntry(paramss).then((res) => { if (res.data) {
          if (res.data.SCODE === "01") { const apiData = res.data.SDESC[0];

                       const options =
                        Object.keys(periodicityMap) .filter((key) => apiData[key] > 0) .map((key) => periodicityMap[key]); setPeriodicitylist(options);
          } else { showAlertMessage(res.data.SDESC, "warning"); }
        }
      });
    }
  };
  const Emptyfields = () => { formik.setFieldValue("periodic_id", ""); formik.setFieldValue("year", ""); formik.setFieldValue("category", ""); }; useEffect(() => {
    MasterService.getDistricts().then((res17) => { if (res17.data) { let options = res17.data.map((item, i) => { return (<option key={i} value={item.id}> {item.value} </option>); }); setDistrictList(options); } }); let params = { userId: username }; MasterService.getApplicableHodsTargets(params).then((res) => { if (res.data) { setDepts(res.data?.SDESC); let options = res.data?.SDESC.map((item, i) => { return (<option key={i} value={item.dept_id}> {item.dept_name} </option>); }); setDeptlist([ { dept_id: "0", dept_name: "All" }, ...(res.data?.SDESC ?? []) ]); } });
    // KpiService.getPeriodicitylist(params).then((res20) => { if (res20.data) { setperiodic(res20.data.SDESC); let options = res20.data.SDESC.map((item, i) => { return (<option key={i} value={item.periodic_id}> {item.periodic_name} </option>); }); setPeriodicitylist(options); } })
  }, []); const YearData = (value) => {
    setYearlist([]);
    formik.setFieldValue("year", "");
    formik.setFieldValue("date", "");
    formik.setFieldValue("category", "");
    setAsotableenb(false);
    setperiodicId(value);
    setId("");
    if (!value) { return; }
    let params = {
      userId: username,
      periodicityId: value
    }
    KpiService.KpiperiodicYears(params).then((res20) => {
      let res = res20.data.SDESC.yearsList
      setyears(res20.data.SDESC.yearsList);
      if (res20.data) {
        let options = res.map((item, i) => {
          return (
            <option key={i} value={item.id}>
              {item.value}
            </option>
          );
        });
        setYearlist(options);
      }
    })
    setYearlist([])
  }
  const Categorydata = (value) => {
    setCategorylist([]);
    if (!value) {
      let missingFields = [];
      if (!value) missingFields.push("Year")
      if (missingFields.length > 0) { const errorMessage = `Please Select Required Field ${missingFields.join(", ")}.`; showAlertMessage(errorMessage, "warning"); } // setCpoTableenb(false)
      setAsotableenb(false)
      return;
    }
    formik.setFieldValue("category", "");
    formik.setFieldValue("date", "");
    const selectedYear = value;
    setId(selectedYear);
    const selectedKey = Object.keys(periodicityMap).find(
      (key) => periodicityMap[key].value === formik.values.periodic_id
    );

    setselectedperiodicity(selectedKey ? periodicityMap[selectedKey].label : "");

    const filteryear = years?.find(item => item.id === value);
    setselectedyear(filteryear?.value);
    setselectedcategory(null);
    if (["116"].includes(roleid)) { const filterdept = Depts?.find(item => item.dept_id === formik.values.department_id); setDeptname(filterdept?.dept_name); } else { setDeptname(localStorage.getItem("deptcodeName")); } const params = {
      userId: username,
      periodicityId: Periodicid,
    };
    KpiService.KpiperiodicYears(params).then((res) => { const response = res.data.SDESC.headList; setcategorys(res.data.SDESC.headList); if (response) { const options = response?.map((item, i) => (<option key={i} value={item.id}> {item.value} </option>)); setCategorylist(options); } else { setCategorylist([]); } });
  };
  const getEntrydata = (value) => { setAsotableenb(false); if (!value) { return; } const filtercategory = categorys?.find(item => item.id === parseInt(value)); setselectedcategory(filtercategory?.value); if (roleid === "114" || roleid === "116") { const params = { userId: username, districtId: "0", mandalId: "0", year: ["1", "2", "3", "8",].includes(formik.values.periodic_id) ? value : formik.values.year, deptId: ["116", "119", "117"].includes(roleid) ? formik.values.department_id : deptId, periodicityId: formik.values.periodic_id, headId: ["1", "2","3", "8"].includes(formik.values.periodic_id) ? "0" : value }; fetchEntryData(params); } }; const fetchEntryData = (params) => {
    store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.gethodLevelKpiIndicaterEntryReport(params).then((res) => {
      store.dispatch({ type: "HIDE_SPINNER" });
      if (res.data.SCODE === "02") {
        showAlertMessage(res.data.SDESC, "warning");
        setEntrydata([]);
        setEntrydataEnb(false);
        setAsotableenb(false);
      }
      else {
        if (res.data.SCODE === "01") {
          let enb = false;
          setAsotableenb(true);
          setEntrydataEnb(true);
          setEntrydata(res.data.SDESC);
          res.data.SDESC.forEach(item => {
            if (item.indicator_value !== null) {
              enb = true;
            }
          });
          setEntrydataEnb(true)
        }
        else {
          showAlertMessage(res.data.SDESC, "warning");
          setEntrydata([]);
          setEntrydataEnb(false);
        }
      }
    }).finally(() => {
      store.dispatch({ type: "HIDE_SPINNER" });
    });
  };
  const filteredData1 = searchText1.length > 0 && EntryData?.length ? EntryData.filter((item) => { return (item && Object.keys(item).some((key) => { const value = item[key]; return (value !== null && value.toString().toLowerCase().includes(searchText1.toLowerCase())); })); }) : EntryData;
  return (<>
    <Menubar />
    <Container fluid className='map-header1'  >
      <div className='sa-title'>
        <h2>HOD Level Indicators  <span> Entry Report</span></h2>
      </div>
    </Container>
    <Container fluid style={{ width: "87%" }} className="outer-page-content-container mt-3">
      <FormikProvider value={formik} >
        <Form onSubmit={formik.handleSubmit}>
          <div className='mandal-container p-4'>
            <Row>
              {(roleid !== "116") && <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='district-select'> <label className="mb-1 fw-bold">Secretariat Name</label>
                <Field className="mb-3 form-control" type="text" name="dept_name" value={localStorage.getItem("SectariatcodeName")} controlId="formBasicEmail" disabled={true} style={{ fontWeight: "bold" }} />  </Col>} <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}  > <label className="mb-1 fw-bold"> HOD Name</label>
               
                    <Select {...commonSelectProps({ name: "department_id", options: Deptlist, value: formik.values.department_id, optionValueKey: "dept_id", optionLabelKey: "dept_name", formik, isDisabled: !["116","119","117"].includes(roleid), extraOnChange: (option) => { perioicitylist(option ? option.dept_id : ""); setAsotableenb(false);Emptyfields(); } })} />
                 </Col>
              {(roleid === "117" || roleid === "111") && <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='mandal-select'>
                <label className="mb-1 fw-bold"> Mandal </label> <span style={{ color: "red" }}> *</span>
                <Field className="mb-3 form-control" component="select" onChange={(e) => { { !e.target.value && setAsotableenb(false) }; formik.handleChange(e) }} name="mandal_id" disabled={Mandalenb} controlId="formBasicEmail" style={{ fontWeight: "bold" }}> <option value="">--Select--</option> <option value="0">All</option> {mandallist} </Field> </Col>}
              <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='mandal-select'>
                <label className="mb-1 fw-bold"> Periodicity </label> <span style={{ color: "red" }}> *</span>
                <Select {...commonSelectProps({ name: "periodic_id", options: Periodicitylist, value: formik.values.periodic_id, optionValueKey: "value", optionLabelKey: "label", formik, isDisabled: false, extraOnChange: (option) => { YearData(option ? option.value : ""); } })} />
    </Col> <>
                <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='mandal-select'>
                  <label className="mb-1 fw-bold"> Year </label> <span style={{ color: "red" }}> *</span>
                  <Select {...commonSelectProps({ name: "year", options: years, value: formik.values.year, optionValueKey: "id", optionLabelKey: "value", formik, isDisabled: false,
                     extraOnChange: (option) => {  if(["1", "2", "3", "8"].includes(formik.values.periodic_id)){getEntrydata(option? option.id:"");}Categorydata(option? option.id:"") } })} />
                  
                </Col>
                {(Periodicid === "5" || Periodicid === "6" || Periodicid === "7") && (<Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='mandal-select'>
                    <label className="mb-1 fw-bold"> Category </label>
                     <span style={{ color: "red" }}> *</span> <Select {...commonSelectProps({ name: "category", options: categorys, value: formik.values.category, optionValueKey: "id", 
                      optionLabelKey: "value", formik, isDisabled: false, extraOnChange: (option) => { getEntrydata(option? option.id:"") } })} />
                </Col>
                )}
                {(Periodicid === "4" && 
                (Id === "2025" || Id === "2024")) && (
                  <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='mandal-select'><label className="mb-1 fw-bold"> Date </label> <span style={{ color: "red" }}> *</span>
                    <Field
                      className="mb-3 form-control" type="date" name="date" onChange={(e) => { getEntrydata(e.target.value);; formik.handleChange(e) }} max={currentDate} controlId="formBasicEmail" style={{ fontWeight: "bold" }} />
                  </Col>
                )}</>
            </Row>
          </div>
          <br />
          {Asotableenb && <>
            <Nav variant="pills" className="flex-column">
              <Row className="tabs-row">
                <Col xxl={2} xl={2} lg={2} md={2} sm={12} xs={12} className="px-0">
                </Col>
                <Col xxl={2} xl={2} lg={2} md={2} sm={12} xs={12} className="px-0">
                </Col>
                <Col xxl={2} xl={2} lg={2} md={2} sm={12} xs={12} className="mx-4 px-4">
                </Col>
                <Col xxl={2} xl={2} lg={2} md={2} sm={12} xs={12} className="mx-4 px-4">
                </Col>
              </Row>
            </Nav>
            <Row>
              <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3">
                <div style={{ display: "flex", alignItems: "center", border: "1px solid #ddd", borderRadius: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px", }}
                  onFocus={(e) => { e.currentTarget.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; e.currentTarget.style.border = "1px solid #353935"; e.currentTarget.style.width = "100%"; }} onBlur={(e) => {
                    e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; e.currentTarget.style.border = "1px solid #ddd"; e.currentTarget.style.width = "150px";
                  }}
                >
                  <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible", }} />
                  <input type="text" placeholder="Search " value={searchText1} onChange={(event) => setSearch1(event.target.value)} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0", }} /> </div>
              </Col>
              <Col className=" mb-2 " >
                <button className="btn btn-danger btn-sm mx-2 pdf-btn" onClick={() => generatePdf("#my-table", "HODLevelKPIIndicatorReport",formik.values.department_id === "0" ? 8:7)} style={{ float: "right", marginLeft: "3px" }} > PDF <MdOutlinePictureAsPdf /> </button>
                <button variant="success" size="sm" className="btn mx-2 excel-btn" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} onClick={() => exportToExcel("my-table", "HODLevelKPIIndicatorReport")} > Excel<AiFillFileExcel style={{ fontSize: "18px" }} /> </button>
              </Col>
            </Row>
            <div style={{ textAlign: "center", backgroundColor: "#d4e3d8" }} className="rounded-1 border py-2 px-2" >
              <span className="style">  {" "} HOD Level Acheivement Report Of Year {selectedyear}</span>
              <br />
              <span className="style-1"> HOD Name:</span>  <span className="style-2">{formik.values.department_id === "0" ? "ALL" : Deptname}</span>
              <span className="style-1"> Periodicity:</span>  <span className="style-2">{selectedperiodicity}</span>
              {selectedcategory && <><span className="style-1"> Category:</span>  <span className="style-2">{selectedcategory}</span></>}
              <div className="text-end style-1">Report On : {currentdate} {currenttime}</div>
            </div>
            <div id="table-scroll" className="table-scroll">
              <div className="table-wrap">
                <table className="table table-bordered custom-table table-responsive sticky-table" id="my-table">
                  <thead style={{ borderRadius: "10px 10px 0px 0px" }} >
                    {entrydataEnb && <>
                      <tr className="text-center only-export"> <th colSpan={formik.values.department_id === "0" ? "8":"7"} style={{ backgroundColor: "#d4e3d8", textAlign: "center" }}>
                        <span className="style">  {" "} HOD Level Acheivement Report Of Year {selectedyear}</span>
                      </th></tr>
                      <tr className="text-center only-export"> <th colSpan={formik.values.department_id === "0" ? "8":"7"} style={{ backgroundColor: "#d4e3d8", textAlign: "center" }}>
                        <span style={{ color: "black" }}> HOD Name:</span> &nbsp; <span style={{ color: "#FBB040" }}>{formik.values.department_id === "0" ? "ALL" : Deptname}</span>
                        <span style={{ color: "black" }}> ,&nbsp;Periodicity:</span> &nbsp; <span style={{ color: "#FBB040" }}>{selectedperiodicity}</span>
                        {selectedcategory && <><span style={{ color: "black" }}> ,&nbsp;Category:</span> &nbsp; <span style={{ color: "#FBB040" }}>{selectedcategory}</span></>}
                      </th></tr>
                      <tr className="only-export"><th colSpan="7"><div className="text-end style-1">Report On : {currentdate} {currenttime}</div></th></tr>
                    </>}
                    <tr className="text-center">
                      <th className="sticky-col sticky-sno">Sl.No.</th>
                      {formik.values.department_id === "0" && <th className="indicator-column">HOD Name</th>}
                      <th className="sticky-col sticky-INDICATOR indicator-column" >INDICATOR</th>
                      <th className="sticky-col sticky-UNIT ">UNIT</th>
                      <th className="indicator-column">Formula</th>
                      <th >NUMERATOR</th>
                      <th >DENOMINATOR</th>
                      <th >ACHIEVED VALUE</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData1?.length === 0 || filteredData1?.length === undefined ? (
                      <tr>
                        <td className="text-center" colSpan={formik.values.department_id === "0" ? "8":"7"}>
                          <b style={{ color: "red" }}>Details Not Found</b>
                        </td>
                      </tr>
                    ) : (
                      (() => {
                        return filteredData1?.map((detail, i) => {
                          return (
                            <tr key={i}>
                              <td style={{ textAlign: "center" }} className="sticky-col sticky-sno">{i + 1}</td>
                              {formik.values.department_id === "0" && <td className="indicator-column"> {detail.dept_name || ""} </td>}
                              <td className="sticky-col sticky-INDICATOR indicator-column" > {detail.indicator_name || ""} </td>
                              <td className="sticky-col sticky-UNIT " style={{ textAlign: "left" }}>{detail.unit || ""}</td>
                              <td style={{ textAlign: "left" }} className="indicator-column">{detail.formula}</td> <td style={{ textAlign: "right" }}>{detail.numerator || ""}</td> <td style={{ textAlign: "right" }}>{detail.denominator || ""}</td> <td style={{ textAlign: "right" }}>{detail.unit_cat_id === 1 ? formatNumberIndianWithDecimal(detail.indicator_value) : detail.indicator_value}</td>
                            </tr>
                          )
                        });
                      })()
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </>
          }
        </Form>
      </FormikProvider>
    </Container>
    <AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} />
  </>
  );
}






